import type { IUser } from "$root/functional-areas/user";
import { EventEmitter } from "eventemitter3";
import { trackMixPanelEvent } from "./initMixPanel";

export type IntercomEventMap = { hide: [void]; show: ["article" | "message" | "space"] };
const intercomEventEmitter = new EventEmitter<IntercomEventMap>();

const IntercomContentsMap = {
	articles: {
		marketRegimeAnalysysTool: 7969565,
		GeographicAndSectorIndicators: 8001000,
		MarketRegimeAnalysis: 7169731,
		globalRiskMap: 10006138,
		createOrOptimisePortfolio: 8027569,
		turnoverPrioritization: 11631519,
		portfolioConstraints: 11730169,
		riskConstraints: 11769361,
		operativeConstraints: 11769194,
		constraintsPriority: 11631519,
	},
};

let mounted = false;
const initIntercom = (): void => {
	if (mounted) {
		return;
	}
	mounted = true;
	(window as any).intercomSettings = {
		api_base: "https://api-iam.intercom.io",
		app_id: "dczh015u",
	};

	const intercomScript = document.createElement("script");
	intercomScript.text = `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/dczh015u';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`;

	document.head.appendChild(intercomScript);
};

export default initIntercom;

export const initIntercomCUser = (user: IUser): void => {
	window.Intercom?.("boot", {
		app_id: "dczh015u",
		email: user.email,
		user_id: (user.customFields as { intercomId?: string } | undefined)?.intercomId,
		//created_at: 1234567890,
	});
	window.Intercom?.("onHide", function () {
		intercomEventEmitter.emit("hide");
	});
};
export const disposeIntercomUser = (): void => {
	window.Intercom?.("shutdown");
};

export const Intercom = {
	showMessage: (): void => {
		if (window.Intercom) {
			window.Intercom("show");
			intercomEventEmitter.emit("show", "article");
		}
	},
	showHelp: (): void => {
		if (window.Intercom) {
			window.Intercom("showSpace", "help");
			intercomEventEmitter.emit("show", "article");
			trackMixPanelEvent("intercom.showHelp", null);
		}
	},
	showArticle: (article: keyof (typeof IntercomContentsMap)["articles"]): void => {
		if (window.Intercom) {
			window.Intercom("showArticle", IntercomContentsMap.articles[article]);
			intercomEventEmitter.emit("show", "article");
			trackMixPanelEvent("intercom.showArticle", [article, IntercomContentsMap.articles[article]]);
		}
	},
	hide: (): void => {
		if (window.Intercom) {
			window.Intercom("hide");
		}
	},
	update: (): void => window.Intercom?.("update"),
	eventEmitter: intercomEventEmitter,
};
